<!-- @veltra/icons generated sha256:c8159059a27036f2 gen:8 source:src/svg/normal/view-module.svg -->
<script setup lang="ts">
defineOptions({ name: 'ViewModule' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm0 3V3h10v2zm0 8V6h10v7zm7.5-5.5h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1m-6 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1"
    />
  </svg>
</template>
